@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$containerName: oddsButton;

[data-fpsm-theme='gazzetta'] {
  .oddsButton {
    background-color: var(--cxy-color-odds-button);

    &:hover {
      background-color: color-mix(in srgb, var(--cxy-color-odds-button), transparent 20%);
    }

    &[disabled] {
      background-color: var(--odds-button-hover, #d7b7b9);
      opacity: 1;

      &:hover {
        background-color: var(--odds-button-hover, #d7b7b9);
      }
    }

    .oddsContainer {
      .line {
        font-weight: var(--cxy-fontWeight-bold);
      }

      .odds {
        font-weight: var(--cxy-fontWeight-bold);
      }
    }
  }
}

.oddsButton {
  container-name: $containerName;
  container-type: inline-size;
  display: flex;
  padding: var(--cxy-spacing-xxxsm);
  min-width: 96px;
  width: 100%;
  background-color: color-mix(in srgb, var(--cxy-color-odds-button), transparent 60%);
  border-radius: var(--cxy-oddsButton-borderRadius, var(--cxy-border-radius-button));

  .lockedIcon {
    color: var(--cxy-color-brand);
    stroke-width: 2px;
  }

  .oddsContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    flex-direction: column;

    .line {
      @include cxy.font-size('text-s');
      margin-block-start: 1px;

      @include cxy.screen-size('desktop') {
        font-weight: var(--cxy-fontWeight-semiBold);
      }
    }

    .odds {
      @include cxy.font-size('text-s');

      &.withLine {
        @include cxy.font-size('text-xs');
        margin-block-start: calc(var(--cxy-spacing-xxxsm) * -1);
      }

      @include cxy.screen-size('desktop') {
        font-weight: var(--cxy-fontWeight-semiBold);
      }
    }
  }

  &:hover {
    opacity: 1;

    color: var(--cxy-color-text-default-body);
    background-color: color-mix(in srgb, var(--cxy-color-odds-button), transparent 50%);
  }
}

@include cxy.container-size($containerName, '140px') {
  .oddsContainer {
    &.direction-row {
      flex-direction: row;
      align-items: center;
      gap: var(--cxy-spacing-xxxsm);

      .odds {
        &.withLine {
          font-size: var(--cxy-fontSize-s);
          line-height: var(--cxy-lineHeight-m);
          opacity: 0.8;
          height: 100%;
          margin-block-start: 0;
        }
      }

      .line {
        line-height: var(--cxy-lineHeight-m);
        font-weight: var(--cxy-fontWeight-bold);
        height: 100%;
        margin-block-start: 0;
      }
    }
  }
}

.oddsButtonWrapper {
  display: flex;
  gap: var(--cxy-spacing-xsm);
  align-items: center;
  width: 100%;

  p {
    text-wrap: nowrap;
  }
}

@media (max-width: 799px) {
  .shouldHideLabelOnMobile.oddsButtonWrapper p {
    display: none;
  }
}

@media (min-width: 800px) {
  .shouldHideLabelOnMobile.oddsButtonWrapper p {
    display: block;
  }

  .oddsButtonWrapper {
    p {
      font-size: var(--cxy-fontSize-xs);
      font-weight: var(--cxy-fontWeight-bold);
      line-height: var(--cxy-lineHeight-m);
    }
  }

  .shouldHideLabelOnDesktop.oddsButtonWrapper p {
    display: none;
  }
}
